import { ARIAS, CLASSES, UPSELL_TABS } from '../../utils/constants';

/**
 * Upsell Tabs (Perfect Pair / Bundles)
 *
 * Uses automatic activation: arrow keys move focus AND activate the tab
 * immediately (WAI-ARIA "automatic" pattern). Roving tabindex ensures only
 * the active tab is in the tab order, so Tab jumps straight to the panel.
 */
const initProductUpsellTabs = () => {
  const tabsEls = document.querySelectorAll('[data-product-upsell-tabs]');
  if (!tabsEls.length) return;

  tabsEls.forEach((tabsEl) => {
    if (tabsEl.dataset.productUpsellTabsInitialised === 'true') return;

    const triggerEls = [...tabsEl.querySelectorAll('[data-upsell-tab-trigger]')];
    const panelEls = [...tabsEl.querySelectorAll('[data-upsell-tab-panel]')];

    if (triggerEls.length < UPSELL_TABS.MINIMUM_TABS || !panelEls.length) {
      tabsEl.dataset.productUpsellTabsInitialised = 'true';
      return;
    }

    /** Activate a tab: update classes, aria-selected, tabindex, and panel visibility. */
    const setActiveTab = (activeTab) => {
      triggerEls.forEach((triggerEl) => {
        const isActive = triggerEl.dataset.tabTarget === activeTab;
        triggerEl.classList.toggle(CLASSES.BG_UPSELL_ACTIVE, isActive);
        triggerEl.classList.toggle(CLASSES.BG_WHITE, !isActive);
        triggerEl.setAttribute(ARIAS.SELECTED, isActive ? 'true' : 'false');
        triggerEl.setAttribute('tabindex', isActive ? '0' : '-1');
      });

      panelEls.forEach((panelEl) => {
        panelEl.classList.toggle(CLASSES.HIDDEN, panelEl.dataset.upsellTabPanel !== activeTab);
      });
    };

    // Validate the default tab exists, fall back to the first trigger
    const defaultTab = tabsEl.dataset.defaultTab;
    const validDefault = defaultTab && triggerEls.some((el) => el.dataset.tabTarget === defaultTab);
    const initialTab = validDefault ? defaultTab : triggerEls[0]?.dataset.tabTarget;
    setActiveTab(initialTab);

    triggerEls.forEach((triggerEl, triggerIndex) => {
      triggerEl.addEventListener('click', () => {
        setActiveTab(triggerEl.dataset.tabTarget);
      });

      // Arrow keys cycle through tabs with automatic activation
      triggerEl.addEventListener('keydown', (event) => {
        let nextIndex = -1;
        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (triggerIndex + 1) % triggerEls.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (triggerIndex - 1 + triggerEls.length) % triggerEls.length;
        }
        if (nextIndex >= 0) {
          event.preventDefault();
          triggerEls[nextIndex].focus();
          setActiveTab(triggerEls[nextIndex].dataset.tabTarget);
        }
      });
    });

    tabsEl.dataset.productUpsellTabsInitialised = 'true';
  });
};

export default initProductUpsellTabs;
